/**
 * Referral attribution helpers.
 *
 * Contract:
 *   - When any page loads with `?ref=CODE`, we persist the code in
 *     sessionStorage so it survives client-side navigation.
 *   - Every form submission that creates a CRM lead reads the code and
 *     includes it in the payload as `referral_code`.
 *   - The code persists across the whole visit (session), then clears when
 *     the tab is closed — deliberately not localStorage so we don't attribute
 *     unrelated later visits.
 */
const KEY = "altura_ref_code";

export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref && typeof ref === "string") {
      const clean = ref.trim().slice(0, 32).toUpperCase();
      if (clean) window.sessionStorage.setItem(KEY, clean);
    }
  } catch (_) {
    /* sessionStorage may be unavailable in restricted contexts */
  }
}

export function getRefCode() {
  try { return window.sessionStorage.getItem(KEY) || null; }
  catch (_) { return null; }
}

export function clearRefCode() {
  try { window.sessionStorage.removeItem(KEY); }
  catch (_) { /* noop */ }
}
